"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Axios = void 0;
var Axios_1 = require("./Axios");
Object.defineProperty(exports, "Axios", { enumerable: true, get: function () { return Axios_1.Axios; } });
exports.default = Axios_1.Axios;
//# sourceMappingURL=index.js.map